import { render, staticRenderFns } from "./viewCompraCerdos.vue?vue&type=template&id=9def37d2"
import script from "./viewCompraCerdos.vue?vue&type=script&lang=js"
export * from "./viewCompraCerdos.vue?vue&type=script&lang=js"
import style0 from "./viewCompraCerdos.vue?vue&type=style&index=0&id=9def37d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports